export default "__VITE_ASSET__691ca2a3__"